import type { DataTableColumn } from '@DataTableModule';
import { AFDataTableColumn, DATA_TABLE_COMPONENTS, FORMAT_COMPONENTS, getCellComponentHelper } from '@DataTableModule';

export default function (field: any) {
  const { FORMAT, INLINE_GROUP, MONEY, TAG } = DATA_TABLE_COMPONENTS;
  const { DATE_TIME_TO_DATE } = FORMAT_COMPONENTS;

  const hasSettings = ['item', 'retail_cost', 'start_date', 'status'];

  const COLUMN: DataTableColumn = new AFDataTableColumn(field, false);

  if (!hasSettings.includes(field.name)) return getCellComponentHelper(field.type, COLUMN);

  switch (field.name) {
    case 'item': {
      return {
        ...COLUMN,
        settings: {
          component: INLINE_GROUP,
          render: {
            header: field?.label,
            badge: {
              targetKey: ['dose_count'],
              unit: 'dose',
              plural: 'doses',
            },
          },
        },
      };
    }
    case 'retail_cost': {
      return {
        ...COLUMN,
        editable: true,
        settings: {
          component: MONEY,
        },
      };
    }
    case 'start_date': {
      return {
        ...COLUMN,
        settings: {
          component: FORMAT,
          render: {
            type: DATE_TIME_TO_DATE,
          },
        },
      };
    }
    case 'status': {
      return {
        ...COLUMN,
        settings: {
          component: TAG,
        },
      };
    }
    default:
      return COLUMN;
  }
}
